export const COMMON_PHASE = {
  PENDING: "PENDING",
  CONCEPTION: "CONCEPTION",
};

export const CT_PHASES = {
  ...COMMON_PHASE,
  EXECUTION: "EXECUTION",
  RECEPTION: "RECEPTION",
};

export const SPS_PHASES = {
  ...COMMON_PHASE,
  REALISATION: "REALISATION",
  DIUO: "DIUO",
};

export const PROJECT_PHASES = {
  ...CT_PHASES,
  ...SPS_PHASES,
};

export const PERMIT_TYPES = {
  PERMIT: "PERMIT",
  AUTHORIZATION: "AUTHORIZATION",
};

export const ENTITY_TYPES = {
  CT: "CT",
  SPS: "SPS",
  SECU: "SECU",
  ITM: "ITM",
};

export const REGISTER_CONSTITUTION = {
  YES: "YES",
  NO: "NO",
};
